import React from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import orbitLogo from '../../Assets/orbit_logo_transparent.png'
import './LoginPage.css'

export default function LoginPage() {
  const { loginWithRedirect } = useAuth0()

  return (
    <div className="auth-login-root">
      <div className="auth-login-card">
        <img src={orbitLogo} alt="Orbit Intel" className="auth-login-logo" />
        <h1 className="auth-login-title">Orbit Intel</h1>
        <p className="auth-login-subtitle">Intelligence Platform</p>
        <div className="auth-login-divider" />
        <button
          className="auth-login-btn"
          onClick={() => loginWithRedirect({ authorizationParams: { prompt: 'select_account' } })}
        >
          Sign In
        </button>
      </div>
      <p className="auth-login-footer">
        © {new Date().getFullYear()} Orbit. All rights reserved.
      </p>
    </div>
  )
}
